'use strict';

// Units 1-8 each get their own flavor dropdown; unit 9+ share a single collapsed
// "+N st" row instead, so the page never shows more than 8 + 1 = 9 pickers (SFCC-3176).
var MAX_INDIVIDUAL_DROPDOWNS = 8;

/**
 * Keeps the visible header selection and list item "selected" state in sync.
 * @param {jQuery} $dropdown - dropdown container element
 */
function syncVariationItemsFromHeader($dropdown) {
    var selectedUrl = $dropdown.find('.selectedValueUrl').val();

    if (!selectedUrl) {
        return;
    }

    $dropdown.find('.variation-item').each(function () {
        var $item = $(this);
        var isSelected = $item.attr('data-url') === selectedUrl;

        $item.find('.variation-span').toggleClass('selected', isSelected);
    });
}

/**
 * The individual per-unit dropdowns (units 1-8), excluding the collapsed "+N st" row.
 * @param {jQuery} $container - product-variations container
 * @returns {jQuery}
 */
function getIndividualDropdowns($container) {
    return $container.find('.dropdown__container').not('.quantum-collapsed-dropdown');
}

/**
 * The single shared dropdown representing every unit beyond MAX_INDIVIDUAL_DROPDOWNS, if present.
 * @param {jQuery} $container - product-variations container
 * @returns {jQuery}
 */
function getCollapsedDropdown($container) {
    return $container.find('.dropdown__container.quantum-collapsed-dropdown');
}

/**
 * Currently selected flavor attribute value for a single dropdown, or null if none selected.
 * @param {jQuery} $dropdown - dropdown__container element
 * @returns {string|null}
 */
function getDropdownSelection($dropdown) {
    var $selectedItem = $dropdown.find('.variation-item .variation-span.selected').closest('.variation-item');
    return $selectedItem.length ? $selectedItem.find('[data-attr-value]').attr('data-attr-value') : null;
}

/**
 * Reads the selected flavor value from each individual unit dropdown (the collapsed
 * "+N st" row is not a unit dropdown and is excluded).
 * @param {jQuery} $container - product-variations container
 * @returns {Array<{attrValue: string}|null>}
 */
function captureUnitDropdownSelections($container) {
    var selections = [];

    getIndividualDropdowns($container).each(function () {
        selections.push({ attrValue: getDropdownSelection($(this)) });
    });

    return selections;
}

/**
 * Applies a flavor selection to a single unit dropdown by attribute value.
 * @param {jQuery} $dropdown - dropdown__container element
 * @param {string} attrValue - variation attribute value id
 * @returns {boolean} - whether the selection was applied
 */
function applySelectionByAttrValue($dropdown, attrValue) {
    var $item = $dropdown.find('.variation-item [data-attr-value="' + attrValue + '"]').closest('.variation-item');

    if (!$item.length) {
        return false;
    }

    var $header = $dropdown.find('.dropdown-header');
    var isSelectable = $item.data('selectable') !== false;
    var $selectedValueUrl = $header.find('.selectedValueUrl');

    $header.attr('data-availability', isSelectable ? 'true' : 'false');
    $selectedValueUrl.val($item.attr('data-url')).attr('value', $item.attr('data-url'));
    $header.find('.title .attr').text($item.data('text'));
    $dropdown.find('.variation-item .variation-span').removeClass('selected');
    $item.find('.variation-span').addClass('selected');

    if (isSelectable) {
        $header.find('.title .no-inventory').addClass('hide');
    } else {
        $header.find('.title .no-inventory').removeClass('hide');
    }

    $header.append($selectedValueUrl);

    return true;
}

/**
 * Re-applies per-unit flavor selections after a first-dropdown variant reload.
 * @param {jQuery} $container - product-variations container
 * @param {Array<{attrValue: string}|null>} selections - captured selections per unit
 * @param {Object} options - restore options
 * @param {boolean} options.skipFirst - skip unit 1 (index 0), which comes from the server response
 */
function restoreUnitDropdownSelections($container, selections, options) {
    if (!selections || !selections.length) {
        return;
    }

    var skipFirst = !options || options.skipFirst !== false;
    var startIndex = skipFirst ? 1 : 0;
    var $dropdowns = $container.find('.dropdown__container');

    for (var i = startIndex; i < selections.length && i < $dropdowns.length; i++) {
        if (selections[i] && selections[i].attrValue) {
            applySelectionByAttrValue($($dropdowns[i]), selections[i].attrValue);
        }
    }
}

/**
 * Highest quantity the stepper/input may reach for a quantum product - the real product
 * max order quantity, whether or not the product has a flavor choice (SFCC-3176/SFCC-3175).
 * @param {jQuery} $productContainer - product detail container
 * @param {jQuery} $quantityInput - quantity input
 * @returns {number}
 */
function getMaxAllowedQuantumQuantity($productContainer, $quantityInput) {
    return parseInt($quantityInput.attr('max'), 10);
}

/**
 * Caps a quantum quantity at the product's real max order quantity.
 * @param {jQuery} $productContainer - product detail container
 * @param {jQuery} $quantityInput - quantity input
 * @param {number} quantity - requested quantity
 * @returns {number}
 */
function clampQuantumQuantity($productContainer, $quantityInput, quantity) {
    var maxQuantity = getMaxAllowedQuantumQuantity($productContainer, $quantityInput);

    if (!isNaN(maxQuantity) && quantity > maxQuantity) {
        return maxQuantity;
    }

    return quantity;
}

/**
 * Activates the promotion box tier matching the current quantity and updates the displayed price.
 * @param {jQuery} $productContainer - product detail container
 * @param {number} productQuantity - selected product quantity
 * @param {number|null} unitPrice - optional unit price after a variant change
 */
function syncQuantumPromotionBox($productContainer, productQuantity, unitPrice) {
    var $tilesContainer = $productContainer.find('.promotion-box-tiles');
    var $tiles = $productContainer.find('.promotion-box-tile');

    if (!$tiles.length) {
        return;
    }

    if (unitPrice != null && !isNaN(unitPrice)) {
        $tilesContainer.attr('data-single-product-price', unitPrice);
        $tiles.attr('data-price', unitPrice);
    }

    var tilesLength = $tiles.length;

    for (var i = tilesLength - 1; i >= 0; i--) {
        var tileQuantity = parseInt($tiles[i].getAttribute('data-quantity'), 10);

        if (productQuantity >= tileQuantity) {
            $tiles.removeClass('active');
            $($tiles[i]).addClass('active');

            var pricePerProduct = parseFloat($tiles[i].getAttribute('data-price'), 10);
            var percentage = parseFloat($tiles[i].getAttribute('data-percentage'), 10);
            var currency = $tiles[i].getAttribute('data-currency');
            var newPrice = productQuantity * (pricePerProduct * (1 - percentage / 100)).toFixed(2);

            $productContainer.find('.prices-and-availability .price-sales').text(
                currency === '€' ? newPrice.toFixed(2) + ' ' + currency : Math.round(newPrice) + ' ' + currency
            );
            break;
        }
    }
}

/**
 * The flavor a newly added unit starts with: unit 1's flavor, whether the quantity changed
 * via stepper, typed quantity or tile click (SFCC-3176 acceptance criterion 4).
 * @param {jQuery} $container - product-variations container
 * @returns {string|null}
 */
function getInheritedSelection($container) {
    return getDropdownSelection(getIndividualDropdowns($container).first());
}

/**
 * Clones a dropdown to use as a new unit's picker (individual unit or the collapsed row).
 * @param {jQuery} $sourceDropdown - dropdown__container to clone from
 * @returns {jQuery}
 */
function cloneDropdownFrom($sourceDropdown) {
    var $clone = $sourceDropdown.clone();
    $clone.removeClass('quantum-collapsed-dropdown');
    $clone.addClass('product-dropdown-clone').addClass('product-item-clone');
    syncVariationItemsFromHeader($clone);
    return $clone;
}

/**
 * Resizes the individual (non-collapsed) unit dropdowns to the target count, defaulting any
 * newly added ones to the inherited flavor (see getInheritedSelection).
 * @param {jQuery} $container - product-variations container
 * @param {number} targetCount - desired number of individual dropdowns (already capped at MAX_INDIVIDUAL_DROPDOWNS)
 */
function resizeIndividualDropdowns($container, targetCount) {
    var $dropdowns = getIndividualDropdowns($container);
    var currentCount = $dropdowns.length;

    if (targetCount > currentCount) {
        var $sourceDropdown = $dropdowns.last();

        if (!$sourceDropdown.length) {
            return;
        }

        var inherited = getInheritedSelection($container);
        var $collapsed = getCollapsedDropdown($container);

        syncVariationItemsFromHeader($sourceDropdown);

        for (var i = currentCount; i < targetCount; i++) {
            var $clone = cloneDropdownFrom($sourceDropdown);

            if (inherited) {
                applySelectionByAttrValue($clone, inherited);
            }

            if ($collapsed.length) {
                $clone.insertBefore($collapsed.closest('.quantum-collapsed-row'));
            } else {
                $clone.insertAfter(getIndividualDropdowns($container).last());
            }
        }
    } else if (targetCount < currentCount) {
        $dropdowns.slice(targetCount).remove();
    }
}

/**
 * Keeps the collapsed row's hidden duplicate URLs (representing the units beyond the one
 * visible picker) in sync with whatever flavor is currently selected on that picker.
 * @param {jQuery} $container - product-variations container
 */
function syncCollapsedDropdownDuplicates($container) {
    var $row = $container.find('.quantum-collapsed-row');

    if (!$row.length) {
        return;
    }

    var selectedUrl = getCollapsedDropdown($container).find('.selectedValueUrl').val() || '';
    $row.find('.quantum-duplicate-url').val(selectedUrl).attr('value', selectedUrl);
}

/**
 * The collapsed row's current flavor selection and represented unit count, so it can survive
 * a unit-1 variant reload (which otherwise rebuilds the row from scratch and loses it).
 * @param {jQuery} $container - product-variations container
 * @returns {{attrValue: string, represents: number}|null}
 */
function captureCollapsedSelection($container) {
    var $collapsed = getCollapsedDropdown($container);

    if (!$collapsed.length) {
        return null;
    }

    return {
        attrValue: getDropdownSelection($collapsed),
        represents: parseInt($collapsed.data('represents'), 10) || 1
    };
}

/**
 * Re-applies a previously captured collapsed-row selection after the row has been rebuilt.
 * @param {jQuery} $container - product-variations container
 * @param {{attrValue: string, represents: number}|null} captured - value from captureCollapsedSelection
 */
function restoreCollapsedSelection($container, captured) {
    if (!captured || !captured.attrValue) {
        return;
    }

    var $collapsed = getCollapsedDropdown($container);

    if ($collapsed.length && applySelectionByAttrValue($collapsed, captured.attrValue)) {
        syncCollapsedDropdownDuplicates($container);
    }
}

/**
 * Creates the collapsed row (cloned from the last individual dropdown) if it doesn't exist yet.
 * The row's count label is wired to the dropdown's picker button via aria-describedby (and
 * announced on change via aria-live) so screen-reader users learn it represents multiple units,
 * not just a single one like the individual pickers (see hsng-accessibility).
 * @param {jQuery} $container - product-variations container
 * @returns {jQuery} - the .quantum-collapsed-row wrapper, or an empty jQuery if it can't be created
 */
function ensureCollapsedRow($container) {
    var $existing = $container.find('.quantum-collapsed-row');

    if ($existing.length) {
        return $existing;
    }

    var $sourceDropdown = getIndividualDropdowns($container).last();

    if (!$sourceDropdown.length) {
        return $();
    }

    var inherited = getInheritedSelection($container);
    var $clone = cloneDropdownFrom($sourceDropdown);
    $clone.addClass('quantum-collapsed-dropdown');
    $clone.find('.quantum-unit-label, .quantum-unit-sr').remove();

    if (inherited) {
        applySelectionByAttrValue($clone, inherited);
    }

    var labelId = 'quantum-collapsed-label-' + Math.random().toString(36).slice(2, 9);
    var $row = $('<div class="quantum-collapsed-row"><span class="quantum-collapsed-label" aria-live="polite"></span></div>');
    $row.find('.quantum-collapsed-label').attr('id', labelId);
    $clone.find('.dropdown-header .title').attr('aria-describedby', labelId);
    $row.append($clone);
    $row.insertAfter($sourceDropdown);

    return $row;
}

/**
 * Adds/removes/updates the single collapsed "+N st" row representing every unit beyond
 * MAX_INDIVIDUAL_DROPDOWNS, including the hidden duplicate URLs add-to-cart needs so each
 * of those units becomes its own basket line item at the collapsed row's flavor (SFCC-3176).
 * @param {jQuery} $container - product-variations container
 * @param {number} newQuantity - total selected quantity
 */
function updateCollapsedRow($container, newQuantity) {
    var extraUnits = newQuantity - MAX_INDIVIDUAL_DROPDOWNS;

    if (extraUnits <= 0) {
        $container.find('.quantum-collapsed-row').remove();
        return;
    }

    var $row = ensureCollapsedRow($container);

    if (!$row.length) {
        return;
    }

    var $collapsedDropdown = $row.find('.quantum-collapsed-dropdown');
    $collapsedDropdown.data('represents', extraUnits);

    var labelTemplate = $container.attr('data-quantum-additional-label');
    $row.find('.quantum-collapsed-label').text(
        labelTemplate ? labelTemplate.replace('{0}', extraUnits) : '+' + extraUnits
    );

    // The collapsed dropdown's own .selectedValueUrl already represents one of these units;
    // the rest are hidden inputs carrying the same value so add-to-cart adds one line item each.
    var duplicatesNeeded = extraUnits - 1;
    var $duplicates = $row.find('.quantum-duplicate-url');

    if ($duplicates.length > duplicatesNeeded) {
        $duplicates.slice(duplicatesNeeded).remove();
    } else {
        for (var i = $duplicates.length; i < duplicatesNeeded; i++) {
            $row.append('<input type="hidden" class="selectedValueUrl quantum-duplicate-url">');
        }
    }

    syncCollapsedDropdownDuplicates($container);
}

/**
 * Puts the unit dropdowns and the collapsed row into a single list that scrolls on its own,
 * so the page doesn't grow with the quantity. Created lazily: a variant reload replaces
 * .product-variations with fresh server markup that has no list.
 * @param {jQuery} $container - product-variations container
 * @returns {jQuery} - the .quantum-flavour-list element
 */
function ensureFlavourList($container) {
    var $list = $container.find('.quantum-flavour-list');

    if (!$list.length) {
        $list = $('<div class="quantum-flavour-list"></div>');
        $list.insertBefore(getIndividualDropdowns($container).first());
    }

    $list.append(getIndividualDropdowns($container).not($list.children()));
    $list.append($container.find('.quantum-collapsed-row'));

    return $list;
}

/**
 * Numbers each individual dropdown ("Enhet 1", "Enhet 2", ...). The visible label is hidden
 * from screen readers; the same text is prefixed inside the picker button instead, so the
 * button's accessible name says which unit it belongs to (see hsng-accessibility).
 * @param {jQuery} $container - product-variations container
 */
function labelUnitDropdowns($container) {
    var template = $container.attr('data-quantum-unit-label') || '{0}';

    getIndividualDropdowns($container).each(function (index) {
        var $dropdown = $(this);
        var text = template.replace('{0}', index + 1);
        var $label = $dropdown.children('.quantum-unit-label');
        var $srText = $dropdown.find('.dropdown-header .title .quantum-unit-sr');

        if (!$label.length) {
            $label = $('<span class="quantum-unit-label" aria-hidden="true"></span>').prependTo($dropdown);
        }

        if (!$srText.length) {
            $srText = $('<span class="quantum-unit-sr"></span>').prependTo($dropdown.find('.dropdown-header .title'));
        }

        $label.text(text);
        $srText.text(text + ': ');
    });
}

/**
 * Removes everything labelUnitDropdowns/ensureFlavourList added, for when the quantity
 * drops back to a single unit and the plain server markup should show again.
 * @param {jQuery} $container - product-variations container
 */
function removeFlavourListDecorations($container) {
    var $list = $container.find('.quantum-flavour-list');

    $container.find('.quantum-unit-label, .quantum-unit-sr, .quantum-flavour-hint, .quantum-flavour-summary').remove();

    if ($list.length) {
        $list.children().insertBefore($list);
        $list.remove();
    }
}

/**
 * Units per flavor across the individual dropdowns and the collapsed row, in the order the
 * flavors first appear, with their display names.
 * @param {jQuery} $container - product-variations container
 * @returns {Array<{attrValue: string, text: string, count: number}>}
 */
function countSelectedFlavours($container) {
    var byValue = {};
    var result = [];

    function add($dropdown, weight) {
        var attrValue = getDropdownSelection($dropdown);

        if (!attrValue) {
            return;
        }

        if (!byValue[attrValue]) {
            byValue[attrValue] = {
                attrValue: attrValue,
                text: $.trim($dropdown.find('.dropdown-header .title .attr').text()),
                count: 0
            };
            result.push(byValue[attrValue]);
        }

        byValue[attrValue].count += weight;
    }

    getIndividualDropdowns($container).each(function () {
        add($(this), 1);
    });

    var $collapsed = getCollapsedDropdown($container);
    if ($collapsed.length) {
        add($collapsed, parseInt($collapsed.data('represents'), 10) || 1);
    }

    return result;
}

/**
 * Discount percentage of the highest promotion tile the quantity reaches, or 0.
 * @param {jQuery} $container - product-variations container
 * @param {number} quantity - total selected quantity
 * @returns {number}
 */
function getTierPercentage($container, quantity) {
    var percentage = 0;

    $container.closest('.product-detail').find('.promotion-box-tile').each(function () {
        if (quantity >= parseInt($(this).attr('data-quantity'), 10)) {
            percentage = parseFloat($(this).attr('data-percentage')) || 0;
        }
    });

    return percentage;
}

/**
 * Updates the hint under the list (explains the collapsed row at and above
 * MAX_INDIVIDUAL_DROPDOWNS) and the summary spelling out the chosen mix, e.g.
 * "44 st · 43 Choklad, 1 Banan -20%". Called after any quantity or flavor change.
 * @param {jQuery|Element} productVariationContainer - .product-variations element
 */
function refreshFlavourSummary(productVariationContainer) {
    var $container = $(productVariationContainer);
    var $list = $container.find('.quantum-flavour-list');

    if (!$list.length) {
        return;
    }

    var $collapsed = getCollapsedDropdown($container);
    var extraUnits = $collapsed.length ? parseInt($collapsed.data('represents'), 10) || 0 : 0;
    var quantity = getIndividualDropdowns($container).length + extraUnits;

    var $hint = $container.find('.quantum-flavour-hint');
    if (!$hint.length) {
        $hint = $('<p class="quantum-flavour-hint" aria-live="polite"></p>').insertAfter($list);
    }

    var hintText = '';
    if (extraUnits > 0) {
        hintText = ($container.attr('data-quantum-hint-collapsed') || '')
            .replace('{0}', extraUnits)
            .replace('{1}', quantity);
    } else if (quantity === MAX_INDIVIDUAL_DROPDOWNS) {
        hintText = $container.attr('data-quantum-hint-max') || '';
    }
    // Only write on change: the hint is aria-live, and rewriting the same text would make
    // some screen readers re-announce it after every flavour pick.
    if ($hint.text() !== hintText) {
        $hint.text(hintText).toggleClass('hide', !hintText);
    }

    var $summary = $container.find('.quantum-flavour-summary');
    if (!$summary.length) {
        $summary = $('<div class="quantum-flavour-summary"><span class="quantum-flavour-summary__text"></span><span class="quantum-flavour-summary__badge"></span></div>')
            .insertAfter($hint);
    }

    var mix = countSelectedFlavours($container).map(function (flavour) {
        return flavour.count + ' ' + flavour.text;
    }).join(', ');
    var percentage = getTierPercentage($container, quantity);

    $summary.find('.quantum-flavour-summary__text').text(
        ($container.attr('data-quantum-summary') || '{0} · {1}').replace('{0}', quantity).replace('{1}', mix)
    );
    $summary.find('.quantum-flavour-summary__badge')
        .text(percentage ? '-' + percentage + '%' : '')
        .toggleClass('hide', !percentage);
}

/**
 * Shows add-to-cart, or notify-me if any unit's flavor is unavailable. Leaves the quantity and
 * stepper alone: the customer must still be able to drop or change the unavailable unit, and
 * overwriting the quantity would desync it from the number of unit pickers (SFCC-3176).
 * @param {jQuery} $productContainer - product detail container
 */
function syncQuantumBuyButton($productContainer) {
    var hasUnavailableUnit = $productContainer.find('.dropdown-header .title .no-inventory').not('.hide').length > 0;

    $productContainer.find('.add-to-cart').toggleClass('hide', hasUnavailableUnit);
    $productContainer.find('.notify-me').toggleClass('hide', !hasUnavailableUnit);
}

/**
 * Adjusts the flavor dropdowns for a quantum product to match the selected quantity: one
 * dropdown per unit up to MAX_INDIVIDUAL_DROPDOWNS, then a single collapsed row for the rest,
 * all inside one numbered, scrollable list with a hint and a summary below it.
 * No-op for products without a flavor choice at all.
 * @param {Element|jQuery} productVariationContainer - .product-variations element
 * @param {number} newQuantity - total selected quantity
 */
function cloneDropdownTiles(productVariationContainer, newQuantity) {
    var $container = $(productVariationContainer);

    if (!getIndividualDropdowns($container).length && !getCollapsedDropdown($container).length) {
        return;
    }

    var $collapsed = getCollapsedDropdown($container);
    var previousQuantity = getIndividualDropdowns($container).length
        + ($collapsed.length ? parseInt($collapsed.data('represents'), 10) || 0 : 0);

    resizeIndividualDropdowns($container, Math.min(newQuantity, MAX_INDIVIDUAL_DROPDOWNS));
    updateCollapsedRow($container, newQuantity);
    // Units were added or removed, so an unavailable flavor may have appeared or gone away.
    syncQuantumBuyButton($container.closest('.product-detail'));

    if (newQuantity <= 1) {
        removeFlavourListDecorations($container);
        return;
    }

    var $list = ensureFlavourList($container);
    labelUnitDropdowns($container);
    refreshFlavourSummary($container);

    // Show the newest unit / the "+N st" row after a quantity change. Not on a variant
    // reload with the same quantity, where jumping the list would lose the customer's place.
    if (newQuantity !== previousQuantity) {
        $list.scrollTop($list[0].scrollHeight);
    }
}

export default {
    cloneDropdownTiles: cloneDropdownTiles,
    refreshFlavourSummary: refreshFlavourSummary,
    syncVariationItemsFromHeader: syncVariationItemsFromHeader,
    captureUnitDropdownSelections: captureUnitDropdownSelections,
    restoreUnitDropdownSelections: restoreUnitDropdownSelections,
    captureCollapsedSelection: captureCollapsedSelection,
    restoreCollapsedSelection: restoreCollapsedSelection,
    syncQuantumPromotionBox: syncQuantumPromotionBox,
    syncCollapsedDropdownDuplicates: syncCollapsedDropdownDuplicates,
    syncQuantumBuyButton: syncQuantumBuyButton,
    clampQuantumQuantity: clampQuantumQuantity
};
